import {
  BarChart,
  Bar,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import { Typography } from "antd";

const { Text } = Typography;

export function StatusBarChart({ data, filters }) {
  let filteredTasks = data.todasLasTareas;
  if (filters.proyecto) {
    filteredTasks = filteredTasks.filter((t) => t.proyectoCodigo === filters.proyecto);
  }
  if (filters.fase) {
    filteredTasks = filteredTasks.filter((t) => t.fase === filters.fase);
  }

  // 🔹 Contar estados
  const statusCounts = {
    completado: filteredTasks.filter((t) => t.estado === "completado").length,
    "en-progreso": filteredTasks.filter((t) => t.estado === "en-progreso").length,
    "en-riesgo": filteredTasks.filter((t) => t.estado === "en-riesgo").length,
    atrasado: filteredTasks.filter((t) => t.estado === "atrasado").length,
  };

  const chartData = [
    {
      name: "Tareas",
      completado: statusCounts.completado,
      "en-progreso": statusCounts["en-progreso"],
      "en-riesgo": statusCounts["en-riesgo"],
      atrasado: statusCounts.atrasado,
    },
  ];

  // 🔹 Configuración visual coherente con el semáforo
  const chartConfig = {
    completado: { label: "Completado", color: "#009728" },
    "en-progreso": { label: "En Progreso", color: "#317EDA" },
    "en-riesgo": { label: "En Riesgo", color: "#FFA500" },
    atrasado: { label: "Atrasado", color: "#D72638" },
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            background: "#fff",
            border: "1px solid #e5e5e5",
            borderRadius: 8,
            padding: 10,
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          }}
        >
          <Text strong style={{ display: "block", marginBottom: 6 }}>
            Estado de Tareas
          </Text>
          {payload.map((entry, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: 13,
              }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: entry.color,
                }}
              />
              <Text>{chartConfig[entry.name]?.label || entry.name}:</Text>
              <Text strong>{entry.value}</Text>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ width: "100%", height: 370 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e5e5" />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} stroke="#888" />
          <YAxis tick={{ fontSize: 12 }} stroke="#888" />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            verticalAlign="bottom"
            height={40}
            formatter={(value) => (
              <span style={{ fontSize: 13, fontWeight: 500 }}>
                {chartConfig[value]?.label || value}
              </span>
            )}
          />
          <Bar dataKey="completado" fill="#009728" stackId="a" radius={[6, 6, 0, 0]} />
          <Bar dataKey="en-progreso" fill="#317EDA" stackId="a" radius={[6, 6, 0, 0]} />
          <Bar dataKey="en-riesgo" fill="#FFA500" stackId="a" radius={[6, 6, 0, 0]} />
          <Bar dataKey="atrasado" fill="#D72638" stackId="a" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
